"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withFeatureFlags = exports.useFeatureFlagsProvider = exports.FeatureFlagsProvider = exports.FeatureFlagsContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var dp_feature_flags_next_lib_1 = require("@greatmindsorg/dp-feature-flags-next-lib");
var config_1 = __importDefault(require("next/config"));
var constants_1 = require("./constants");
var publicRuntimeConfig = (0, config_1.default)().publicRuntimeConfig;
/**
 * Configurations needed to call the useFeatureFlags
 * appName: Name of the app on Unleash
 * serverUrl: Path to the feature flag unleash api
 */
var FEATURE_FLAGS_CONFIG = {
    appName: '',
    serverUrl: publicRuntimeConfig.FEATURE_FLAGS_SERVER_URL || constants_1.FEATURE_FLAG_API_BASE_URL,
};
/**
 * Feature Flags context that will provide an object of
 * a property string for the feature flag name and a boolean value for enablement
 */
exports.FeatureFlagsContext = (0, react_1.createContext)(null);
/**
 * Feature Flags Provider that will receive children and the appName for which the provider will be used on
 * Retrieves feature flags for the app from the feature flags api using the useFeatureFlags hook
 * Returns features flag formatted as the value of the provider
 * Example: <FeatureFlagsProvider appName="dp-student-app">
 */
var FeatureFlagsProvider = function (_a) {
    var children = _a.children, appName = _a.appName;
    FEATURE_FLAGS_CONFIG.appName = appName;
    var _b = (0, dp_feature_flags_next_lib_1.useFeatureFlags)(FEATURE_FLAGS_CONFIG), isEnabled = _b[1];
    var featureFlags = (0, react_1.useMemo)(function () {
        var _a;
        return Object.entries((_a = constants_1.FEATURE_FLAGS_PER_APP[appName]) !== null && _a !== void 0 ? _a : {}).map(function (_a) {
            var key = _a[0], value = _a[1];
            var featureFlag = {};
            featureFlag["".concat(key)] = isEnabled(value);
            return featureFlag;
        });
    }, [appName, isEnabled]);
    var featureFlagsFormatted = featureFlags.reduce(function (obj, item) {
        obj = __assign(__assign({}, obj), item);
        return obj;
    }, {});
    return ((0, jsx_runtime_1.jsx)(exports.FeatureFlagsContext.Provider, { value: featureFlagsFormatted, children: children }));
};
exports.FeatureFlagsProvider = FeatureFlagsProvider;
/**
 * Custom hook to use the feature flags provider
 *  Example: const featureFlags = useFeatureFlagsProvider()
 *  featureFlags[FEATURE_FLAGS[NAME]] or featureFlags[FEATURE_FLAGS.NAME] will give if it is enabled or not
 */
var useFeatureFlagsProvider = function () { return (0, react_1.useContext)(exports.FeatureFlagsContext); };
exports.useFeatureFlagsProvider = useFeatureFlagsProvider;
/**
 * Custom HOC to wrap components around
 * HOC will retrieve feature flags from API and check whether the Feature Flag passed is enabled
 * If so, it will show the component, otherwise return null
 * Example: export default withFeatureFlags(DpItemsCarousel, FEATURE_FLAGS.NAME)
 */
var withFeatureFlags = function (Component, featureFlag) {
    return function (props) {
        var featureFlags = (0, exports.useFeatureFlagsProvider)();
        if (featureFlags[featureFlag]) {
            return (0, jsx_runtime_1.jsx)(Component, __assign({}, props));
        }
        return null;
    };
};
exports.withFeatureFlags = withFeatureFlags;
